import { useEffect, useState } from 'react';

const getPlayerContainer = () =>
  document.querySelector('[data-player="bluebook"]');

function useGetPlayerEl() {
  const [playerEl, setPlayerEl] = useState(getPlayerContainer());

  useEffect(() => {
    setPlayerEl(getPlayerContainer());
  }, []);

  return playerEl;
}

export default useGetPlayerEl;
